// extracted by mini-css-extract-plugin
export default {"snackbar":"styles__snackbar___GO0R4"};